import React, { PureComponent, Fragment } from 'react'
import { IconButton, Menu, MenuItem, ListItemIcon, ListItemText } from '@material-ui/core'
import {
  MoreHoriz,
  DescriptionOutlined,
  SubtitlesOutlined,
  Sort,
  DateRange
} from '@material-ui/icons'

const menuItems = [
  { id: 'reset', label: 'Скинути сортування', Icon: Sort },
  { id: 'sheet', label: 'Роздрукувати відомість', Icon: DescriptionOutlined },
  { id: 'tickets', label: 'Роздрукувати квитки', Icon: SubtitlesOutlined },
]

const partnerMenuItems = [
  { id: 'reset', label: 'Скинути сортування', Icon: Sort },
  { id: 'rangeBookings', label: 'Роздрукувати бронювання', Icon: DateRange },
]

export class BookingsOptionsBase extends PureComponent {
  state = {
    anchorEl: null
  }

  onOptionClick = type => () => {
    const { onSortResetClick, showModal, ticketBookings, bookings, returnBookings } = this.props

    /* eslint-disable */
    switch (type) {
      case 'reset':
        onSortResetClick()
        break
      case 'sheet':
        showModal({ type: 'printBookingsSheet', data: { bookings, returnBookings } })
        break
      case 'tickets':
        showModal({ type: 'printTickets', data: { bookings: ticketBookings } })
        break
      case 'rangeBookings':
        showModal({ type: 'selectRange' })
        break
      default:
        return
    }
    /* eslint-enable */

    this.handleClose()
  }

  renderMenuItem = ({ id, label, Icon }) => (
    <MenuItem key={id} onClick={this.onOptionClick(id)}>

      <ListItemIcon>
        <Icon />
      </ListItemIcon>

      <ListItemText inset primary={label} />

    </MenuItem>
  )

  handleOpen = e => this.setState({ anchorEl: e.currentTarget })

  handleClose = () => this.setState({ anchorEl: null })

  render() {
    const { anchorEl } = this.state
    const { classes, isPartner, isLimitedDispatcher } = this.props

    return (
      <Fragment>
        <IconButton onClick={this.handleOpen} className={classes.moreIcon}>
          <MoreHoriz />
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={this.handleClose}
        >
          {isPartner || isLimitedDispatcher
            ? partnerMenuItems.map(this.renderMenuItem)
            : menuItems.map(this.renderMenuItem)}
        </Menu>
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Bookings/components/BookingsOptions/BookingsOptions.js